export const isObjectEmpty = (obj: object) => {
  return Object.values(obj).filter((i) => i !== '').length === 0;
};
